import { Link } from 'react-router-dom'

import styles from './InviteEmailDesign.module.scss'

const InviteEmailDesignCardIconButton = ({
  label,
  onClick,
  href,
  variant = 'default',
  disabled = false,
  children
}) => {
  const className = [
    styles.cardIconButton,
    variant === 'danger' ? styles.cardIconButtonDanger : '',
    variant === 'primary' ? styles.cardIconButtonPrimary : ''
  ]
    .filter(Boolean)
    .join(' ')

  if (href) {
    return (
      <Link className={className} to={href} title={label} aria-label={label}>
        {children}
      </Link>
    )
  }

  return (
    <button
      type="button"
      className={className}
      title={label}
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default InviteEmailDesignCardIconButton
